// extracted by mini-css-extract-plugin
export default {"share":"ShareButtons_share__WlS8e","social":"ShareButtons_social__tdzD-","socialMediaButton":"ShareButtons_socialMediaButton__M1xst","icon":"ShareButtons_icon__eqlzu"};